import MissingSlugVariableError from "../../errors/MissingSlugVariableError";
import normalizeProduct from "../../utils/normalizations/normalize-product";
import { requireConfigValue } from "../../isomorphic-config";
const defaultImagesSize = requireConfigValue("imagesSize");
const defaultImagesQuality = requireConfigValue("imagesQuality");
export default function getProductVariantOperation({ commerce  }) {
    async function getProductVariant({ query ="" , variables: getProductVariantVariables , config: userConfig  }) {
        var ref;
        //Uncomment the following line to debug
        /* console.log(
      'getProductVariant called. Configuration: ',
      'getProductVariantVariables: ',
      getProductVariantVariables,
      'config: ',
      userConfig
    ) */ if (!(getProductVariantVariables == null ? void 0 : getProductVariantVariables.slug)) {
            throw new MissingSlugVariableError();
        }
        // Extract the 'metal' option value from the product slug
        const metalOptionValueSlugs = [
            "white-&-yellow-gold-14k",
            "white-&-yellow-gold-18k",
            "white-gold-14k",
            "white-gold-18k",
            "yellow-gold-14k",
            "yellow-gold-18k",
            "rose-gold-14k",
            "rose-gold-18k",
            "platinum", 
        ];
        const optionValueSlug = metalOptionValueSlugs.find((opt)=>getProductVariantVariables.slug.includes(opt));
        const masterSlug = optionValueSlug ? getProductVariantVariables.slug.replace(`-${optionValueSlug}`, "") : getProductVariantVariables.slug;
        const optionValue = (ref = optionValueSlug == null ? void 0 : optionValueSlug.replace(/-/g, " ")) == null ? void 0 : ref.toLowerCase();
        const variables = {
            methodPath: "products.show",
            arguments: [
                masterSlug,
                {},
                {
                    include: "primary_variant,variants,images,option_types,variants.option_values,taxons,product_properties",
                    image_transformation: {
                        quality: defaultImagesQuality,
                        size: getProductVariantVariables.imagesSize || defaultImagesSize
                    }
                }, 
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config // TODO: Send config.locale to Spree.
        ;
        const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
            variables
        });
        const normalizedProduct = normalizeProduct(spreeSuccessResponse, spreeSuccessResponse.data);
        const variant = normalizedProduct.variants.find((variant)=>{
            return variant.options.find((option)=>{
                if (option.__typename === "MultipleChoiceOption" && option.displayName.toLowerCase() === "metal") {
                    return option.values.find((v)=>v.label.toLowerCase() === optionValue);
                }
            });
        });
        return {
            variant: variant
        };
    }
    return getProductVariant;
};
